import EventDispatcher from "helpers/EventDispatcher";

interface EventMap {
  open: IPopupContent;
  close: null;
}

export default new EventDispatcher<EventMap>();
